import { useTranslation } from 'react-i18next'
import React from 'react'

import { useColors, useGetColor } from '../../packages/kiti/components/theme/_hooks/colors'
import Tag from '../../components/presentation/Tag'

export const STATUS = 'status'
export const PRIORITY = 'priority'

const useStatusColor = (type, name, item) => {
  const colors = useColors()
  const getColor = useGetColor()
  if (!name) return false
  if (type === PRIORITY) {
    switch (name) {
      case 'low':
        return colors.green
      case 'medium':
        return colors.yellow
      case 'high':
        return colors.red
      case 'critical':
        return colors.darkRed
    }
  }

  return getColor(item?.color)
}

const StatusTag = ({ item, name, type, ...props }) => {
  const { t } = useTranslation()
  name = name || item?.name
  const color = useStatusColor(type, name, item)
  if (!name) return false

  type = type || STATUS
  const label = item?.label || t(type + '.' + name)

  return <Tag label={label} bgColor={color} {...props} />
}

export default StatusTag
